/**
 * Updates model values based on input parameters.
 *   Used to ensure the loan does not receive values it no longer needs.
 *
 * @param {*} model - List of fields and values provided by this request.
 */
export const sanitizeModel = (model) => {
  if (model.getIn(['loan', 'refiPurpose']) === 'RateAndTerm') {
    model = model.setIn(['loan', 'cashOutValue'], null);
    if (model.getIn(['loan', 'refiCurrentProduct']) === 'None') {
      model = model.setIn(['loan', 'refiCurrentProduct'], null);
    }
  } else if (
    model.getIn(['loan', 'refiPurpose']) === 'CashOut' &&
    model.getIn(['loan', 'refiCurrentProduct']) === 'None'
  ) {
    model = model.setIn(['loan', 'refiCurrentRate'], null);
    model = model.setIn(['loan', 'purchasePrice'], null);
  }
  return model;
};



// WEBPACK FOOTER //
// ./src/modules/sanitizer.js